<template>
  <div>
    <h2 class="font-weight-bold mb-4">Confirm account and agreement</h2>
    <div class="bank_info">
      <b-row>
        <b-col cols="12" sm="12" md="4" lg="4">
          <p class="font-weight-bold">Bank Name:</p>
          <p>RCBC Savings Bank</p>
        </b-col>
        <b-col cols="12" sm="12" md="4" lg="4">
          <p class="font-weight-bold">Account holder name:</p>
          <p>Waa Sadasd Asdasd</p>
        </b-col>
        <b-col cols="12" sm="12" md="4" lg="4">
          <p class="font-weight-bold">Account number:</p>
          <p>2342342342342343</p>
        </b-col>
      </b-row>
    </div>
    <div class="account_confirm">
      <p>We have sent a confirmation code to your phone number:</p>
      <p class="num">0 221 233 2311</p>
      <b-link>You can change if you made a mistake</b-link>
    </div>
    <b-row>
      <b-col cols="12" sm="12" md="6" lg="6">
        <b-form-group label="Code from SMS" label-for="smscode">
          <b-form-input id="smscode" type="number" required placeholder="SMS Code"></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <div class="d-flex justify-content-end mb-4 next">
      <button @click.prevent="$router.push('/registration/step-6')" type="submit">Next Step</button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
.bank_info {
  padding: 20px;
  margin-bottom: 20px;
  border-radius: 6px;
  background: $base-bgcolor-lightblue;
  border: 1px solid rgba(0, 0, 0, 0.08);
}
.account_confirm {
  padding: 20px;
  margin-bottom: 20px;
  border-radius: 6px;
  background: #fff4db;
  border: 1px solid rgba(0, 0, 0, 0.08);
  .num {
    font-size: 30px;
    font-weight: 700;
  }
}
</style>